import React from 'react';
import { useTranslation } from 'react-i18next';

import { Typography } from '@dev/ee-components';
import { TrackingSectionWrapper } from '../../../styled';
import { TrackOpens } from './components/TrackOpens';
import { TrackClicks } from './components/TrackClicks';
import { SendCampaignStats } from './components/SendCampaignsStats';
import { TrackLinksGA } from './components/TrackLinksGA';

export const Tracking = (): JSX.Element => {
    const { t } = useTranslation();

    return (
        <TrackingSectionWrapper>
            <Typography variant="h2">{t('tracking')}</Typography>
            <TrackOpens />
            <TrackClicks />
            <SendCampaignStats />
            <TrackLinksGA />
        </TrackingSectionWrapper>
    );
};
